/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UtilHttpRowAffBody model module.
 * @module model/UtilHttpRowAffBody
 * @version 1.0
 */
class UtilHttpRowAffBody {
    /**
     * Constructs a new <code>UtilHttpRowAffBody</code>.
     * @alias module:model/UtilHttpRowAffBody
     */
    constructor() { 
        
        UtilHttpRowAffBody.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UtilHttpRowAffBody</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UtilHttpRowAffBody} obj Optional instance to populate.
     * @return {module:model/UtilHttpRowAffBody} The populated <code>UtilHttpRowAffBody</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UtilHttpRowAffBody();

            if (data.hasOwnProperty('rowAff')) {
                obj['rowAff'] = ApiClient.convertToType(data['rowAff'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} rowAff
 */
UtilHttpRowAffBody.prototype['rowAff'] = undefined;






export default UtilHttpRowAffBody;

